import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

const IpSetup = () => {
  const [ipAddress, setIpAddress] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setIpAddress(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("ipConfig", ipAddress);
    navigate("/")
    window.location.reload();
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">INSTRUCTION</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="ip-address" className="form-label">Enter IP Address:</label>
          <input
            type="text"
            className="form-control"
            id="ip-address"
            value={ipAddress}
            onChange={handleInputChange}
            placeholder="Enter IP"
            required
          />
        </div>
        <div className="text-center">
          <button type="submit" className="btn btn-primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default IpSetup;
